// SPDX-License-Identifier: BUSL-1.1

/**
 * Unified Activity tab (sessions + jobs merged).
 *
 * Extracted from `routes/agent-detail.tsx` during the P3b refactor.
 */

import { DataTable } from '@/components/data-table';
import { activityColumns } from './activity-columns';
import type { ActivityItem, Job } from './types';

export function ActivityTab({
  activityData,
  onSelectJob,
  onSelectRunningSession,
}: {
  activityData: ActivityItem[];
  onSelectJob: (job: Job) => void;
  onSelectRunningSession: (sessionId: string) => void;
}) {
  return (
    <DataTable
      columns={activityColumns}
      data={activityData}
      emptyMessage="No activity found for this agent."
      onRowClick={(row) => {
        if (row.type === 'job') {
          onSelectJob(row as unknown as Job);
        } else if (row.type === 'session' && row.status === 'running') {
          onSelectRunningSession(row.id);
        }
      }}
    />
  );
}
